module.exports = {
  title: 'Animated 3D Parallax with Reanimated 🌌',
  author: 'Enzo Manuel Mangano',
  date: '2023-05-24',
  slug: 'animated-3d-parallax',
  tags: ['reanimated', 'gesture-handler'],
};
